import React from 'react'
import { ThemeProvider } from 'styled-components/macro'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { defaultTheme } from '../../../ui'

class StoreThemeProvider extends React.PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    store: PropTypes.object.isRequired
  }

  render () {
    const storeTheme = theme => ({
      ...theme,
      cover_photo: this.props.store.cover_photo,
      ...this.props.store.theme

    })

    return (
      <ThemeProvider theme={storeTheme(defaultTheme)}>
        {React.cloneElement(this.props.children, this.props)}
      </ThemeProvider>
    )
  }
}

export default withRouter(StoreThemeProvider)
